import React, { createContext, useContext, useMemo } from 'react';

type ContextType = {
  isInModal: boolean;
};

const defaultContext: ContextType = {
  isInModal: false
};

const FilterMenuContext = createContext<ContextType>(defaultContext);

export type OwnProps = React.PropsWithChildren<{
  isInModal?: boolean;
}>;

export function FilterMenuContextProvider({
  children,
  isInModal = false
}: OwnProps) {
  const value = useMemo<ContextType>(
    (): ContextType => ({
      isInModal
    }),
    [isInModal]
  );

  return (
    <FilterMenuContext.Provider value={value}>
      {children}
    </FilterMenuContext.Provider>
  );
}

FilterMenuContextProvider.displayName = 'FilterMenuContextProvider';

export default FilterMenuContext;

export function useFilterMenuContext() {
  return useContext(FilterMenuContext);
}

export function useIsInModal() {
  return useContext(FilterMenuContext).isInModal;
}
